import createAction from 'utils/redux-helpers/createAction';

const handler = state =>
  state.setIn(['user', 'status'], 'Active').setIn(['user', 'dueBalance'], 0);

export const payDebt = createAction({
  action: ['payDebt'],
  handler,
});
